import { render, staticRenderFns } from "./ChangePriceForAuthor.vue?vue&type=template&id=a7cfc532"
import script from "./ChangePriceForAuthor.vue?vue&type=script&lang=js"
export * from "./ChangePriceForAuthor.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceForAuthor.vue?vue&type=style&index=0&id=a7cfc532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports